export default function MockApi () {
  return {
    async getCards () {
      return [...new Array(50).fill().map((_, index) => ({
        id: String(index),
        title: `Card ${index}`,
        description: `This is card number ${index}`,
      }))]
    },
  }
}
